import {useMediaQuery} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {FeatureBlock} from 'entities/credits'
import {
  GetPackages,
  PackageType,
  setConfirmPayModal,
  setPackageModalOpen,
  setPackages,
  usePackageModal,
  usePaymentPackages
} from 'entities/payment'
import {Packages} from 'features/packages'
import {getDiscount, getPerCoinValue, names} from 'shared/lib'
import {text} from 'shared/mirrors/text'
import {Button} from 'shared/ui/buttons'
import {ArrowLeft, Close} from 'shared/ui/icons'
import {Modal} from 'shared/ui/modal'
import styles from './styles.module.scss'

export const PackageModal: React.FC = () => {
  const dispatch = useDispatch()
  const packages = usePaymentPackages()
  const isOpen = usePackageModal()
  const [selectedPackage, setSelectedPackage] = useState(0)
  const [isReady, setIsReady] = useState(false)
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)

  const onCloseHandler = () => dispatch(setPackageModalOpen(false))

  const onClickHandler = (id: number) => setSelectedPackage(id)

  const onContinueHandler = () => {
    dispatch(setConfirmPayModal({isOpen: true, ...packages.find(item => item.id === selectedPackage)}))
    onCloseHandler()
  }

  useEffect(() => {
    if (!isOpen) return setIsReady(false)

    GetPackages()
      .then(({data}) => {
        const packages = data.data
        dispatch(setPackages(packages))

        if (packages.length === 1) {
          dispatch(setConfirmPayModal({isOpen: true, ...data.data[0]}))
          return onCloseHandler()
        }
        //set middle package as default package
        setSelectedPackage(packages[Math.ceil(packages.length / 2 - 1)].id)
        setIsReady(true)
      })
      .catch(console.error)

  }, [isOpen])

  if (!isReady) return <></>

  return (
    <Modal disableEnforceFocus open={isOpen} onClose={onCloseHandler}>
      <div className={styles.containerWrapper} onClick={onCloseHandler}>
        <div className={styles.container} onClick={(e) => e.stopPropagation()}>
          <div className={styles.header}>
            <div className={styles.btnArrow} onClick={onCloseHandler}>
              <ArrowLeft />
            </div>
            <h2 className={styles.title}>
              Package selection
            </h2>
            <div onClick={onCloseHandler} className={styles.closeBtn}>
              <Close />
            </div>
          </div>
          <div className={names(styles.packages, is768p ? styles.customScroll : '')}>
            {is768p ?
              <Packages />
              :
              packages.map((item) =>
                <Package key={item.id} isSelected={item.id === selectedPackage} onClick={onClickHandler} {...item} />
              )
            }
          </div>
          <div className={styles.footer}>
            <Button onClick={onContinueHandler} styleType='primary' className={styles.btnContinue}>Continue</Button>
            <p className={styles.terms}>{text.main.estoniaAddress} and its affiliates</p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

type PackageProps = PackageType & {
  isSelected: boolean
  onClick: (id: number) => void
}

const Package: React.FC<PackageProps> = ({
  id,
  name,
  credits,
  stickers,
  photos,
  videos,
  virtualGifts,
  price,
  originPrice,
  isSelected,
  onClick
}) => {
  const withSale = originPrice && originPrice !== price

  return (
    <div
      onClick={() => onClick(id)}
      className={`${styles.package} ${isSelected ? styles.package_selected : ''}`}
    >
      {withSale ? <div className={styles.discount}>
        -{getDiscount(price, originPrice)}% off
      </div> : null}
      <div className={`${styles.package__title} ${isSelected ? styles.package__title_selected : ''}`}>
        <h5 className={styles.title}>
          {name}
        </h5>
        <span className={styles.perCoin}>~ ${getPerCoinValue(price, credits)} per coin</span>
      </div>
      <div className={styles.features}>
        <FeatureBlock
          credits={credits}
          stickers={stickers}
          photos={photos}
          videos={videos}
          virtualGifts={virtualGifts}
        />
      </div>
      <div className={styles.pricing}>
        <h5 className={`${styles.cost} ${isSelected ? styles.cost_selected : ''}`}>
          ${price}
        </h5>
        {withSale ? <span className={styles.originPrice}>
          ${originPrice}
        </span> : null}
      </div>
    </div>
  )
}